import {
	Select,
	Text,
	Textarea,
	Upload,
	TimeDuration,
	Number,
	FormGroupInterface,
	FORM_TYPE,
	VALIDATION_TYPE,
	DFORM_BUTTON_DIRECTION,
	Aadhar,
	InputGroup,
	DDate,
	STRING
} from 'projects/common/src/app/types';
export function getAADetailForm(data: any = {}, on: any = {}, disable: any= {}) {
	const aaDetailsForm: FormGroupInterface = {
		label: data.label || '',
		type: FORM_TYPE.WITHOUT_STYLE,
		labelDiv: 3,
		inputDiv: 8,
		forms: [
			{
				label: '',
				disabled: true,
				formElements: [
					new Text('Name', {
						name: 'aaName',
						align: 6,
					}),
					new Text('ID', {
						name: 'aaUserName',
						align: 6,
					}),
				]
			},
			{
				label: 'Address Details',
				disabled: true,
				formElements: [
					new Textarea('Address:', {
						name: 'address',
					}),
					new Text('Near Landmark', {
						name: 'landmark',
					}),
					new Text('Pincode', {
						name: 'pincode',
					}),
					new Text('State / Union Teritory', {
						name: 'state',
					}),
					new Text('District', {
						name: 'district',
					}),
					// new Text('Tehsil / Mandal / Block', {
					// 	name: 'tehsil',
					// }),
					// new Text('City / Village / Town', {
					// 	name: 'village',
					// }),
					new Text('Parliamentary Constituency', {
						name: 'parliamentaryConstituency',
					}),
				]
			}, {
				label: '',
				disabled: true,
				formElements: [
					new Text('Name of the SPOC:', {
						name: 'spocName',
						align: 6
					}),
					new Text('Email Address:', {
						name: 'email',
						align: 6
					}),
					new Text('Phone Number:', {
						name: 'mobileNumber',
						align: 6
					})
				]
			}
		]
	};
	return aaDetailsForm;
}
